import PraisoServices from "./PraisoServices";
import { getDeviceId } from "./LocalStorageService";

export const LoginUserAPI = async (email, password, deviceType) => {
  const ApiUrl = `auth/login`;
  const deviceId = getDeviceId()
  try {
    const response = await PraisoServices(
      ApiUrl,
      "post",
      {
        email: email,
        password: password,
        deviceType: deviceType,
        deviceId: deviceId,
        timezoneOffset: (new Date()).getTimezoneOffset()
      },
      {},
      {
        "Access-Control-Allow-Origin": "*"
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const getLoginUser = async (email, password) => {
  // @todo: need to check how this could be dynamic / static
  const deviceType = 0;
  const data = await LoginUserAPI(email, password, deviceType);
  return data;
  // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
  //   return data;
  // } else {
  //   return data;
  // }
};

export const LoginSSOUserAPI = async (email, ssoToken, deviceType) => {
  const ApiUrl = `auth/login`;
  const deviceId = getDeviceId()
  try {
    const response = await PraisoServices(
      ApiUrl,
      "post",
      {
        email: email,
        ssoToken: ssoToken,
        deviceType: deviceType,
        deviceId: deviceId,
      },
      {},
      {
        "Access-Control-Allow-Origin": "*"
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const getSSOLoginUser = async (email, ssoToken) => {
  const deviceType = 0;
  const data = await LoginSSOUserAPI(email, ssoToken, deviceType);
  return data;
};
